import moment from 'moment'
import { CalculateAge } from '../utils/CalculateAge'
import { sequenceTableTemplate } from '../utils/squenceTableNo'
import { formatDate, formatDateTime } from '../utils/FormateDateTime'

export const LaborderdummyData = [
  {
    id: 1,
    OrderNo: 'ORD-00123',
    updated_at: '2025-07-11T10:45:00Z',
    subject: {
      id: 'PAT-1001',
      name: {
        given: 'John',
        family: 'Doe'
      },
      birth_date: '1990-05-12'
    },
    requester: {
      name: {
        given: 'Alice',
        family: 'Smith'
      }
    },
    progress_status: 'In Progress',
    status: 'Pending'
  },
  {
    id: 2,
    OrderNo: 'ORD-00124',
    updated_at: '2025-07-10T14:30:00Z',
    subject: {
      id: 'PAT-1002',
      name: {
        given: 'Emily',
        family: 'Johnson'
      },
      birth_date: '1985-09-20'
    },
    requester: {
      name: {
        given: 'Robert',
        family: 'Brown'
      }
    },
    progress_status: 'Completed',
    status: 'Approved'
  },
  {
    id: 3,
    OrderNo: 'ORD-00125',
    updated_at: '2025-07-09T08:15:00Z',
    subject: {
      id: 'PAT-1003',
      name: {
        given: 'Michael',
        family: 'Lee'
      },
      birth_date: '2000-03-05'
    },
    requester: {
      name: {
        given: 'Sarah',
        family: 'Williams'
      }
    },
    progress_status: 'Pending Review',
    status: 'On Hold'
  }
]

export const LabOrderColumns = t => [
  {
    body: sequenceTableTemplate,
    header: t('No'),
    style: { width: '3rem' },
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'order_no',
    header: t('Order No'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'authored_on',
    header: t('Date'),
    headerCellClass: '!bg-gray-200'
  },
  // {
  //   field: 'patient.id',
  //   header: t('Patient ID'),
  //   headerCellClass: '!bg-gray-200'
  // },
  {
    field: 'patient.name',
    header: t('Patient Name'),
    headerCellClass: '!bg-gray-200',
  },
  {
    field: 'patient.dob',
    header: t('Patient Age'),
    headerCellClass: '!bg-gray-200',
    body: rowData => CalculateAge(rowData?.patient.dob)
  },
  {
    field: 'practitioner.name',
    header: t('Doctor'),
    headerCellClass: '!bg-gray-200',

  },
  // {
  //   field: 'order_type',
  //   header: t('Order Type'),
  //   headerCellClass: '!bg-gray-200'
  // },
  {
    field: 'status',
    header: t('Status'),
    headerCellClass: '!bg-gray-200'
  }
]

export const LabOrderItemsColumns = t => [
  {
    body: sequenceTableTemplate,
    header: t('No'),
    style: { width: '3rem' },
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'service_type',
    header: t('Service Type'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'service_code',
    header: t('Item Code'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'service_desc',
    header: t('Service Description'),
    headerCellClass: '!bg-gray-200'
  },

  // {
  //   field: 'unit_price',
  //   header: t('Unit Price'),
  //   headerCellClass: '!bg-gray-200',
  //   body: rowData => `SAR ${rowData?.unit_price?.toFixed(2) ?? '0.00'}`
  // },
  {
    field: 'quantity',
    header: t('Quantity'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'item_type',
    header: t('Item Type'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'progess_status',
    header: t('Progress Status'),
    headerCellClass: '!bg-gray-200'
  }
]

export const labOrderItemsData = [
  {
    serviceType: 'laboratory',
    itemCode: 'LAB123',
    serviceDescription: 'Standard Laboratory Test',
    effectiveDate: '2023-05-15',
    unitPrice: 480,
    quantity: 1,
    factor: 0,
    status: 'ending'
  },
  {
    serviceType: 'radiology',
    itemCode: 'RAD456',
    serviceDescription: 'X-Ray Examination',
    effectiveDate: '2023-06-01',
    unitPrice: 320,
    quantity: 2,
    factor: 1.5,
    status: 'active'
  },
  {
    serviceType: 'consultation',
    itemCode: 'CON789',
    serviceDescription: 'Specialist Consultation',
    effectiveDate: '2023-04-10',
    unitPrice: 150,
    quantity: 1,
    factor: 0,
    status: 'terminated'
  },
  {
    serviceType: 'pharmacy',
    itemCode: 'PHA012',
    serviceDescription: 'Prescription Medication',
    effectiveDate: '2023-05-20',
    unitPrice: 75,
    quantity: 3,
    factor: 0,
    status: 'active'
  }
]
